module.exports = __webpack_public_path__ + "static/media/color_Diamonds.5509bd14.jpg";